export default __webpack_public_path__ + "static/SRUS AP680 - Especification Del Producto y Datos Técnicos-df28b9d5369f2ba924d5592425d4ff1b.pdf";